import { RouteObject } from 'react-router-dom';
import { ProvidersPage } from '@/features/providers/pages/ProvidersPage';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { RegionsPage } from '@/features/regions/pages/RegionsPage';
import RegionsIndexPage from '@/app/regions/page';
import RegionSearchPage from '@/app/regions/search/page';

export const protectedRoutes: RouteObject[] = [
  { 
    path: 'providers', 
    element: (
      <ErrorBoundary>
        <ProvidersPage />
      </ErrorBoundary>
    )
  },
  { 
    path: 'providers/:providerId/regions', 
    element: (
      <ErrorBoundary>
        <RegionsPage />
      </ErrorBoundary>
    )
  },
  {
    path: 'regions',
    element: (
      <ErrorBoundary>
        <RegionsIndexPage />
      </ErrorBoundary>
    )
  },
  {
    path: 'regions/search',
    element: (
      <ErrorBoundary>
        <RegionSearchPage />
      </ErrorBoundary>
    )
  }
];